import { ref } from 'vue';

function useFocusState(containerRef, triggerSelector, navDirection = "vertical") {
  const currentFocusIndex = ref(0);
  const getFocusableTiggerElements = () => {
    const focusableTiggerElements = containerRef.value.querySelectorAll(`:where(${triggerSelector}):not([disabled])`);
    if (focusableTiggerElements && focusableTiggerElements.length) return focusableTiggerElements;
    return [];
  };
  const setFocus = (index) => {
    const elements = getFocusableTiggerElements();
    if (elements[index] && typeof elements[index].focus === "function") {
      elements[index].focus();
    }
  };
  const moveFocusToFirstItem = () => {
    currentFocusIndex.value = 0;
    setFocus(currentFocusIndex.value);
  };
  const moveFocusToLastItem = () => {
    const elements = getFocusableTiggerElements();
    currentFocusIndex.value = elements.length - 1;
    setFocus(currentFocusIndex.value);
  };
  const getNextItemIndex = () => {
    const elements = getFocusableTiggerElements();
    const nextFocusIndex = currentFocusIndex.value + 1;
    if (nextFocusIndex > elements.length - 1) {
      return 0;
    }
    return nextFocusIndex;
  };
  const getPrevItemIndex = () => {
    const elements = getFocusableTiggerElements();
    const prevFocusIndex = currentFocusIndex.value - 1;
    if (prevFocusIndex < 0) {
      return elements.length - 1;
    }
    return prevFocusIndex;
  };
  const moveFocusToNextItem = () => {
    const nextFocusIndex = getNextItemIndex();
    setFocus(nextFocusIndex);
    currentFocusIndex.value = nextFocusIndex;
  };
  const moveFocusToPrevItem = () => {
    const prevFocusIndex = getPrevItemIndex();
    setFocus(prevFocusIndex);
    currentFocusIndex.value = prevFocusIndex;
  };
  const onElementKeydown = (event) => {
    if (navDirection === "vertical") {
      switch (event.key) {
        case "ArrowUp":
          return moveFocusToPrevItem();
        case "ArrowDown":
          return moveFocusToNextItem();
        case "Home":
          return moveFocusToFirstItem();
        case "End":
          return moveFocusToLastItem();
        default:
          return null;
      }
    } else if (navDirection === "horizontal") {
      switch (event.key) {
        case "ArrowLeft":
          return moveFocusToPrevItem();
        case "ArrowRight":
          return moveFocusToNextItem();
        case "Home":
          return moveFocusToFirstItem();
        case "End":
          return moveFocusToLastItem();
        default:
          return null;
      }
    }
  };
  return {
    currentFocusIndex,
    onElementKeydown
  };
}

export { useFocusState };
